import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/politica-cancelamento-reembolso')({
  component: CancellationRefundPage,
});

function CancellationRefundPage() {
  return (
    <div
      className="min-h-[60vh] bg-[#CCD0CF] text-[#06141B]"
      style={{ fontFamily: 'Poppins, sans-serif' }}
    >
      <div className="mx-auto max-w-4xl px-6 py-12 space-y-8">
        <h1 className="text-2xl sm:text-3xl font-semibold mb-2">
          Política de Cancelamento e Reembolso — Prometeus
        </h1>
        <p className="text-sm text-[#253745] mb-6">
          Esta política unifica as regras de cancelamento e reembolso aplicáveis aos planos do Prometeus, incluindo efeitos do cancelamento, elegibilidade a reembolso, prazos e procedimentos.
        </p>
        <p className="text-sm text-[#253745] mb-8">
          Ao contratar, renovar ou utilizar um plano pago, o usuário concorda com estas condições, além dos Termos e Condições e da Política de Privacidade, quando publicados.
        </p>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold text-[#06141B]">Cancelamento</h2>
          
          <h3 className="text-lg font-medium text-[#11212D] mt-4">Como cancelar</h3>
          <p className="text-sm text-[#253745] mb-3">O usuário pode cancelar a assinatura a qualquer momento:</p>
          <div className="space-y-2 text-sm text-[#253745] ml-4">
            <p>• Pelo painel do Prometeus (quando houver a opção de cancelamento).</p>
            <p>• Pelo suporte, a partir do e-mail cadastrado, informando dados mínimos para identificar a conta (ex.: e-mail de login e CPF/CNPJ se aplicável).</p>
          </div>
        </section>

        <section className="space-y-4">
          <h3 className="text-lg font-medium text-[#11212D]">Efeitos do cancelamento</h3>
          <div className="space-y-3 text-sm text-[#253745]">
            <p>
              O cancelamento interrompe a renovação automática, mas a assinatura permanece ativa até o fim do período já pago, salvo condição diferente expressa na oferta/contrato.
            </p>
            <p>
              O cancelamento, por si só, não implica reembolso automático, exceto nas hipóteses previstas nesta política.
            </p>
          </div>
        </section>

        <section className="space-y-4">
          <h3 className="text-lg font-medium text-[#11212D]">Prazos para evitar renovação</h3>
          <div className="space-y-3 text-sm text-[#253745]">
            <p>
              Recomenda-se solicitar o cancelamento com antecedência mínima de 24 a 72 horas da data de renovação, por prazos de processamento do meio de pagamento.
            </p>
            <p>
              Se houver cobrança após o pedido, o caso será analisado conforme registros do pedido e a confirmação do processador de pagamento.
            </p>
          </div>
        </section>

        <section className="space-y-4">
          <h3 className="text-lg font-medium text-[#11212D]">Downgrade (opção alternativa)</h3>
          <div className="space-y-3 text-sm text-[#253745]">
            <p>
              Quando disponível, o usuário pode optar por downgrade para um plano inferior em vez de cancelar, com efeitos imediatos ou na próxima renovação conforme indicado na tela de mudança de plano.
            </p>
          </div>
        </section>

        <section className="space-y-4">
          <h3 className="text-lg font-medium text-[#11212D]">Inadimplência e violação de termos</h3>
          <div className="space-y-3 text-sm text-[#253745]">
            <p>
              A falta de pagamento pode resultar em tentativas de cobrança, suspensão temporária e posterior encerramento, conforme a política comercial vigente.
            </p>
            <p>
              A conta também pode ser suspensa/encerrada por fraude, abuso, uso ilícito ou violação dos Termos, sem obrigação de reembolso, salvo determinação legal.
            </p>
          </div>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold text-[#06141B]">Reembolso</h2>
          
          <h3 className="text-lg font-medium text-[#11212D] mt-4">Quando há reembolso</h3>
          <p className="text-sm text-[#253745] mb-3">Haverá reembolso quando:</p>
          <div className="space-y-2 text-sm text-[#253745] ml-4">
            <p>• Existir garantia/“teste sem risco” prevista na oferta vigente (ex.: X dias após a primeira contratação), se o cancelamento ocorrer dentro do prazo e nas condições informadas no momento da compra.</p>
            <p>• Houver falha técnica relevante e comprovada que impeça o uso do serviço de forma substancial, sem solução em prazo razoável, podendo o Prometeus optar por reembolsar ou conceder crédito/extensão equivalente (conforme o caso).</p>
            <p>• Houver cobrança indevida (ex.: duplicidade) confirmada após verificação.</p>
          </div>
        </section>

        <section className="space-y-4">
          <h3 className="text-lg font-medium text-[#11212D]">Quando não há reembolso</h3>
          <p className="text-sm text-[#253745] mb-3">Em regra, não há reembolso:</p>
          <div className="space-y-2 text-sm text-[#253745] ml-4">
            <p>• Por simples desistência após o início do ciclo e fora de eventual período de garantia divulgado.</p>
            <p>• Por não uso do serviço durante o período contratado.</p>
            <p>• Em casos de bloqueio por violação de termos, fraude, abuso ou uso indevido.</p>
          </div>
        </section>

        <section className="space-y-4">
          <h3 className="text-lg font-medium text-[#11212D]">Reembolso em planos anuais (se aplicável)</h3>
          <div className="space-y-3 text-sm text-[#253745]">
            <p>
              Se o Prometeus oferecer plano anual e prever reembolso proporcional, ele poderá ser calculado pro-rata, descontando-se valores já utilizados e eventuais encargos/taxas explicitadas no momento da contratação, quando aplicável.
            </p>
            <p>
              Se não houver previsão expressa de pro-rata no ato da compra/contrato, aplica-se a regra geral de inexistência de reembolso por cancelamento fora do período de garantia.
            </p>
          </div>
        </section>

        <section className="space-y-4">
          <h3 className="text-lg font-medium text-[#11212D]">Prazo e forma do reembolso</h3>
          <div className="space-y-3 text-sm text-[#253745]">
            <p>
              O reembolso, quando aprovado, será processado preferencialmente pelo mesmo meio de pagamento utilizado na compra, respeitando prazos operacionais do provedor financeiro.
            </p>
            <p>
              O prazo de análise começa a contar do envio das informações necessárias e pode exigir validações (ex.: logs, status da assinatura e comprovantes).
            </p>
          </div>
        </section>

        <section className="space-y-4">
          <h3 className="text-lg font-medium text-[#11212D]">Dados após cancelamento (retenção e exportação)</h3>
          <div className="space-y-3 text-sm text-[#253745]">
            <p>
              Após o término do período pago, o Prometeus pode manter os dados por um período de retenção para permitir exportação e eventual reativação, quando tecnicamente viável.
            </p>
            <p>
              Após esse prazo, os dados podem ser excluídos ou anonimizados, observadas obrigações legais e regras de privacidade.
            </p>
          </div>
        </section>

        <section className="space-y-4">
          <h3 className="text-lg font-medium text-[#11212D]">Como solicitar reembolso ou contestar cobrança</h3>
          <div className="space-y-3 text-sm text-[#253745]">
            <p>
              A solicitação deve ser feita pelo suporte a partir do e-mail cadastrado, informando: identificação da conta, motivo do pedido e detalhes da cobrança.
            </p>
            <p>
              Pedidos serão respondidos com status (aprovado/negado/pendente de informação) e, se aprovado, com o registro do processamento.
            </p>
            <div className="mt-4 p-4 bg-[#9BA8AB] bg-opacity-20 rounded-lg">
              <p className="font-medium mb-2">Canais de atendimento:</p>
              <p className="text-sm">E-mail: contato@mourarezende.com.br</p>
              <p className="text-sm">Telefone: (91) 9 8904-5502</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

